import * as types from './types'

export default {
  [types.NULL]: '',
  [types.HOME]: 'Home',
  [types.DATA_OVERVIEW]: 'Dashboard',
  [types.LABEL_MARKET]: 'Audience Tag',
  [types.CROWD_MANAGEMENT]: 'Segment Management',
  [types.CROWD_LIST]: 'Segment List',
  [types.CROWD_ID]: 'Segment ID',
  [types.LOOKALIKE_TOOL]: 'Lookalike Tool',
  [types.CONFIGURE_CENTER]: 'Configuration',
  [types.ORDER_TAG]: '订单标签组合',
  [types.E_COMMERCE_INSIGHT]: '电商标签每周流量洞察',
  [types.INQUIRY_MANAGE]: '问询管理',
  [types.INQUIRY_MANAGE_ORIGIN]: '问询源包',
  [types.INQUIRY_MANAGE_PUSH]: '推送列表',
  [types.INQUIRY_TASK]: '问询标签',
  [types.ALGORITHM_MODEL]: '算法模型',
  [types.TAG_CONFIG]: 'Tag Configuration',
  [types.APP_FLOW_QUERY]: 'App Inventory',
  [types.PROJECT_TAG]: 'Project Tag',
  [types.SYNC_CONTROL]: 'Sync Control',
  [types.INQUIRY]: '1st Party DMP API',
  [types.INQUIRY_NAMAGE]: 'Segment Task',
  [types.TAG_PUBLISH]: 'Tag Publish',
  [types.DNA]: 'DNA',
  [types.DMP]: 'DMP',
  [types.ALL]: 'All',
  [types.OVERALL]: 'Overall',
  [types.PERSON_LABEL]: 'Individual',
  [types.FAMILY_LABEL]: 'Household',
  [types.PERSON_LABEL_LIST]: 'Individual List',
  [types.FAMILY_LABEL_LIST]: 'Household List',
  [types.LABEL_CROWD]: 'Tag Segment',
  [types.UPLOAD_CROWD]: 'Upload Segment',
  [types.COMBINE_CROWD]: 'Combined Segment',
  [types.LBS_CROWD]: 'LBS Segment',
  [types.LBS_BATCH_ADDRESS]: '批量获取地址',
  [types.LOOKALIKE_CROWD]: 'Lookalike Segment',
  [types.BIDDEN_CROWD]: 'Post-campaign Segment',
  [types.ALGORITHM_CROWD]: 'Algorithm Segment',
  [types.THIRDPARTDMP_CROWD]: '1st Party DMP',
  [types.COMPARE_CROWD]: 'Compare',

  [types.ALL_CROWD]: 'All Segments',
  [types.MY_CROWD]: 'My Segments',
  [types.CROWD_NAME]: 'Segment Name',
  [types.EDIT_FORM_CROWD_NAME]: 'Name',
  [types.EDIT_FORM_COMBINE_CONDITION]: 'OP',
  [types.EDIT_FORM_DEFAULT_CONDITION]: 'Default',
  [types.EDIT_FORM_DEFAULT_CONDITION_LAST]: 'Last',
  [types.EDIT_FORM_DEFAULT_CONDITION_NONE]: 'None',
  [types.ORDER_NUMBER]: 'No.',
  [types.LABEL_STATUS]: 'label status',
  [types.OPERATOR]: 'operator',
  [types.OPERATIONTIME]: 'operation time',

  [types.SEARCH_INPUT_PLACEHOLDER]: 'Search by tag name, e.g. Gender',
  [types.SEARCH_BUTTON]: 'Search',
  [types.TAG_EXPLAIN]: 'Tag Description',
  [types.HOT_WORD]: 'Top Search',
  [types.ENTER_CROWD_CONDITION]: 'Add to Segment',
  [types.TAG_NAME]: 'Tag',
  [types.COVERAGE_YOYI_ID]: 'YOYI ID',
  [types.OPERATION]: 'Actions',
  [types.COVERAGE_YOYI_HHID]: 'HouseholdID',
  [types.PROPORTION]: 'Coverage %',
  [types.TAG_SEARCH_RESULT]: '{total} tags found for \'{keyword}\'',
  [types.TAG_SEARCH_LABEL]: '用户标签-{keyword} 标签： 共计 {total}个',
  [types.TAG_CLOUD]: 'Tag Cloud',
  [types.ID_ATLAS]: 'ID Graph',
  [types.ID_ATLAS_USER]: 'YOYI ID',
  [types.ID_ATLAS_FAMILY]: 'Household ID',
  [types.OVERVIEW_TAG_CLOUD_CHART_INTRO]: 'DNA tags in the geographic location, media preferences, consumer preferences, consumption scenarios, top 100 leaf tags in each dimension\'s YOYI ID coverage',
  [types.OVERVIEW_TAG_CLOUD_FAMILY_CHART_INTRO]: 'DNA家庭标签在媒体偏好，消费偏好，节目偏好，地理位置每个维度HouseholdID覆盖量前100的叶子标签',
  [types.OVERVIEW_ID_MAP_CHART_INTRO]: 'The number of IDs of each type and the relationship between them',
  [types.OVERVIEW_ID_MAP_FAMILY_CHART_INTRO]: '展示HouseholdID和其中可跨屏部分的数量情况',
  [types.OVERVIEW_INDUSTRY_CHART_INTRO]: 'The number of YOYIIDs covered by each feature population generated by algorithm processing',
  [types.OVERVIEW_AVERAGE_CHART_INTRO]: 'Use box plot to show the distribution of the number of labels covered by YOYIID in each dimension',
  [types.OVERVIEW_AVERAGE_FAMILY_CHART_INTRO]: '使用箱型图展示HouseholdID在每个维度覆盖标签数量分布情况',
  [types.TERRITORY_DISTRIBUTE]: 'Geo',
  [types.TAG_DISTRIBUTE]: 'Tag Coverage',
  [types.INDUSTRY_CROWD]: 'Predefined Segments',
  [types.BASE_ATTRIBUTE]: 'Demographics',
  [types.BASE_ATTRIBUTE_TOTAL]: 'Total',
  [types.GENDER]: 'Gender',
  [types.AGE]: 'Age',
  [types.AVERAGE_TAG_DISTRIBUTE]: 'Tag Statistics',
  [types.AVERAGE_FAMILY_TAG_DISTRIBUTE]: 'Family Tag Statistics',
  [types.INTEREST]: 'Preference',
  [types.INTEREST_FAMILY]: 'Family Preference',
  [types.INTEREST_INTERMEDIARY_HABIT]: 'Media',
  [types.INTEREST_TERMINAL_BRAND]: 'Phone',
  [types.RECENT_ID_TREND]: 'ID number trend in the last 30 days',
  [types.RECENT_HOUSEHOLD_ID_TREND]: 'Household ID number trend in the last 30 days',
  [types.FEMALE]: 'Female',
  [types.MALE]: 'Male',
  [types.BASE_INFO]: '基础信息',
  [types.POTENTIAL_CONSUMER_REQUEST]: '潜在消费需求',
  [types.HIGH]: 'Max',
  [types.LOW]: 'Min',
  [types.CHINA]: 'China',
  [types.BASE_SORT]: 'All Tags',
  [types.COMMIT_DATE]: 'Create Date',
  [types.NO_MORE_THAN_60]: 'The longest support period is 60 days.',
  [types.END_LIMIT_WITH_TODAY]: 'The end date should not exceed today.',
  [types.CREATE_SUCCESS]: 'Create success',
  [types.PLEASE_INPUT_CROWD_NAME]: 'Please enter segment name',
  [types.PLEASE_INPUT_PLACE_NAME]: 'Please enter place name',
  [types.PLEASE_INPUT_FTP_PATH]: 'Please enter FTP path',
  [types.AD_EMPLOYER]: 'Advertisers',
  [types.PROJECT]: 'Project',
  [types.CHANNEL]: 'Channel',
  [types.PLEASE_SELECT_FILES]:'Please select files',
  [types.PLEASE_SELECT_FILE]:'Please select a file',
  [types.PLEASE_SELECT_PROJECT]:'Please select a project',
  [types.PLEASE_SELECT_TAGS]: 'Please select tags',
  [types.PLEASE_SELECT_SEGMENTS]: 'Please select segments',
  [types.PLEASE_SELECT_SEGMENT]: 'Please select a segment',
  [types.PLEASE_SELECT_API]: 'Please select API',
  [types.PLAN]: 'Campaign',
  [types.PLEASE_SELECT_PLAN]: 'Please select a time campaign',
  [types.ORDER]: 'Order',
  [types.CREATIVITY]: 'Creative',
  [types.CYCLE]: 'Look Back',
  [types.PLEASE_SELECT_CYCLE]: 'Please select a time period',
  [types.BEHAVIOR_CONDITION]: 'conversion',
  [types.CLICK_NOT_CONVERSION]: '点击未转化',
  [types.FREQUENCY]: 'Frequency',
  [types.UNLIMITED]: 'All',
  [types.MORE_THAN_TWO_TIMES]: '>=3',
  [types.MORE_THAN_FIVE_TIMES]: '>=6',
  [types.CUSTOM]: 'Custom',
  [types.CI_JI_YI_SHANG]: '次及以上',
  [types.TERMINAL_TYPE]: 'Device',
  [types.SYSTEM_TYPE]: 'OS',
  [types.CREATE]: 'Create',
  [types.CANCEL]: 'Cancel',
  [types.COMBINE_CONDITION]: 'Combination',
  [types.COMMIT]: 'Submit',
  [types.COMBINE_RESULT]: 'Combination',
  [types.DATA_NOT_AVAILABLE]: 'No Data',
  [types.RESET]: 'Reset',
  [types.SEQUENCE]: 'No.',
  [types.COVERAGE_USER]: 'Coverage',
  [types.COVERAGE_UPLOAD]: 'Matched ID #',
  [types.TYPE]: 'Type',
  [types.MOST_20_PERSON]: 'Up to 20 packages can be selected for combination',
  [types.MOST_2_SEGMENT_COMPARE]: 'Up to 2 packages can be selected for compare',
  [types.TOTAL]: 'Total {total} items',
  [types.PLEASE_UPLOAD_FILE]: 'Please upload file!',
  [types.PLEASE_UPLOAD_EXCEL]: 'Please upload EXCEL file!',
  [types.FILE_COUNT_MOST_1]: 'Upload up to 1 file!',
  [types.ONLY_EXCEL_CSV_TXT]: 'Only support EXCEL,CSV, TXT files',
  [types.FILE_SIZE_LESS_THAN_1G]: 'File size up to 1G!',
  [types.FILE_SIZE_LESS_THAN_6G]: 'File size up to 6G!',
  [types.RANGE_TIP]: 'Start range cannot be greater than the end range!',
  [types.UPLOAD_SUCCESS]: 'Upload Success',
  [types.CREATE_CROWD]: 'Create Segment',
  [types.EDIT_CROWD]: 'Edit Segment',
  [types.CROWD_DEFINATION]: 'Tags for Segement',
  [types.ADD_TO_SEGMENT]: 'Create',
  [types.DOWNLOAD_TEMPLATE]: 'Download Template',
  [types.FILE_SIZE_ATTENTION]: 'Note: Maximum file size is 1GB.',
  [types.INPUT_TOO_LONG]: 'Input character is too long',
  [types.UPLOAD]: 'Upload',
  [types.UPLOAD_FILE]: 'Upload File',
  [types.SELECT_FILE]: 'Select File',
  [types.SUPPORT_CSV_TXT]: 'Support csv,txt',
  [types.SUPPORT_EXCEL_CSV_TXT]: 'Support xls,xlsx,csv,txt',
  [types.CROWD_FILE_NAME]: 'Segment Name',
  [types.ID_TYPE]: 'ID Type',
  [types.ID_SIGN]: 'ID Sign',
  [types.SELECT_ID_TYPE]: 'Please select ID type',
  [types.THIRD_PARTY]: 'Third Party',
  [types.THIRD_PARTY_COOKIE]: '3rd Party Cookie',
  [types.TOTAL_USER]: 'Total ID #',
  [types.STATUS]: 'Status',
  [types.YOYI_MATCHING_RATIO]: 'Matching Rate',
  [types.MAINTAIN_DATE]: 'Update Date',
  [types.INVALID_DATE]: 'Expire Date',
  [types.CREATOR]: 'Creator',
  [types.SEARCH_WITH_CROWD_NAME]: 'Search by segment name',
  [types.PROCESS_FILE_TIME]: 'Each file takes about 1.5 hours to match.',
  [types.CROWD_NAME_OBSCURE_SEARCH]: 'Search by Segment Name',
  [types.DELAY_SUCCESS]: 'Extend Success',
  [types.DELAY]: 'Extend',
  [types.CONFIRM]: 'OK',
  [types.CREATE_TIME]: 'Create Date',
  [types.INVALID_TIME]: 'Expire Date',
  [types.SET_DELAY]: 'Extend To',
  [types.DELAY_UNTIL]: 'Extend To',
  [types.SPREAD_SUCCESS]: 'Diffuse Success',
  [types.SPREAD_CROWD]: 'Lookalike',
  [types.SPREAD]: 'OK',
  [types.CROWD_PACKAGE]: 'Segment',
  [types.LOOK_LIKE_NAME]: 'Lookalike Segment Name',
  [types.PLEASE_INPUT_SPREAD_CROWD_NAME]: 'Please enter the name of the segment after the diffuse',
  [types.CROWD_SPREAD_CONDITION]: 'Lookalike Dimension',
  [types.PLEASE_SELECT_SPREAD_CROWD_CONDITION]: 'Please select lookalike dimension',
  [types.ONLY_UNLIMITED_SPREAD_CONDITION]: 'No restriction is selected, and no other diffusion conditions can be selected',
  [types.CROWD_SPREAD_TIMES]: 'Expand',
  [types.PLEASE_INPUT_SPREAD_TIMES]: 'Please fill in the diffusion multiple',
  [types.SPREAD_TIMES_1_10]: 'Diffusion multiples 1-10',
  [types.TIMES]: 'Times',
  [types.TIMES_]: 'Times',
  [types.START_LATE_END]: 'Start time is later than end time',
  [types.CAN_NOT_SYNC_WITHOUT_AD_EMPLOYER]: 'No advertiser information, can\'t sync',
  [types.SYNC_PLUS_SUCCESS]: 'Sync to PLUS success',
  [types.SYNC_PLATFORM_SUCCESS]: 'Sync to platform success',
  [types.MY_AD_EMPLOYER]: 'My Advertiser',
  [types.GET_AD_EMPLOYER_FAIL]: 'Failed to get advertiser',
  [types.SYNC_PLUS]: 'Sync to PLUS',
  [types.SYNC_PLATFORM]: 'Sync to Platform',
  [types.SYNC_THIRD]: 'Sync to Third-Party Inquiry',
  [types.SELECT_AD_EMPLOYER]: 'Advertisers',
  [types.PLEASE_SELECT_AD_EMPLOYER]: 'Select Advertisers',
  [types.START_TIME]: 'Start Date',
  [types.PLEASE_SELECT_START_TIME]: 'Please select the start date',
  [types.START_DATE]: 'Start Date',
  [types.END_TIME]: 'End Date',
  [types.PLEASE_SELECT_END_TIME]: 'Please select the end date',
  [types.END_DATE]: 'End Date',
  [types.CLEAR]: 'Clear',
  [types.START_COMBINE]: 'Combine',
  [types.START_COMPARE]: 'Compare',
  [types.CURRENT_STATUS_COUNT]: 'Current Status',
  [types.CROWD_TOTAL]: 'Total',
  [types.CROWD_TYPE]: 'Segment Type',
  [types.ALL_STATUS]: 'All',
  [types.ALL_TYPES]: 'All',
  [types.CROWD_PACKAGE_AUTO_UPDATE]: 'Auto Update',
  [types.TASK_NO_START_PLEASE_WAIT]: 'The task has not started yet,please try again later',
  [types.CREATE_CROWD_PACKAGE_PLEASE_WAIT]: 'Segment is generating,please try again later',
  [types.SYNC_CROWD_PACKAGE_PLEASE_WAIT]: 'Segment is synchronizing,please try again later',
  [types.CROWD_PACKAGE_OUTDATE_CAN_NOT_AUTO_UPDATE]: 'Segment has expired,automatic update is not supported',
  [types.MODIFY_AUTO_UPDATE_STATUS]: 'Modify Status to',
  [types.AUTO_UPDATE]: 'Auto Update',
  [types.NO_AUTO_UPDATE]: 'Not Update',
  [types.UPDATE_SUCCESS]: 'Modify Success',
  [types.CROWD_PACKAGE_ADDED]: 'Segment has been added',
  [types.MAKING_CROWD_PACKAGE_PLEASE_WAIT]: 'Segment is generating,please try again later',
  [types.UNSUPPORTED_COMBINE_WITHOUT_LOOKALIKE]: 'Lookalike has not generated,combine is not supported',
  [types.UNSUPPORTED_COMBINE_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,combine is not supported',
  [types.UNSUPPORTED_DELAY_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,delay is not supported',
  [types._DELETE]: 'Delete',
  [types.CAN_NOT_DELETE_WHEN_MAKING_CROWD_PACKAGE]: 'Segment is generating,delete is not supported',
  [types.CAN_NOT_DELETE_WHEN_SYNCING_CROWD_PACKAGE]: 'Segment is synchronizing,delete is not supported',
  [types.CAN_NOT_DELETE_AFTER_CROWD_PACKAGE_SYNC_PLUS]: 'Segment has been synchronized to PLUS,delete is not supported',
  [types.CAN_NOT_DELETE_DMP_CROWD_PACKAGE]: 'DMP segment can not be deleted',
  [types.SURE_TO_DELETE_CROWD_XXX]: 'Please Confirm to delete Segment: {name} ?',
  [types.NEW_TYPE_CROWD_WITHOUT_CONFIGURED]: 'Invalid Segment',
  [types.DELETE_SUCCESS]: 'Delete Success',
  [types.EDIT]: 'Edit',
  [types.DOWNLOAD]: 'Download',
  [types.COPY]: 'Copy',
  [types.CHECK]: 'Check',
  [types.CAN_NOT_EDIT_WHEN_SYNCING_CROWD_PACKAGE]: '正在同步人群包，不支持编辑',
  [types.CAN_NOT_EDIT_WHEN_CROWD_PACKAGE_SYNCED_PLUS]: 'Segment has been synchronized to PLUS,edit is not supported',
  [types.CAN_NOT_EDIT_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,edit is not supported',
  [types.CAN_NOT_EDIT_WITH_FUZZY_SEARCH_LBS]: 'LBS segment generated by fuzzy search,edit is not supported',
  [types.CROWD_INSIGHT]: 'Segment Insight',
  [types.CROWD_INSIGHT_OVERVIEW]: 'Overview',
  [types.AD_TRAFFIC]: 'Inventory Analysis',
  [types.CROWD_FLOW_INSIGHT]: 'Segment Flow Insight',
  [types.MAKING_INSIGHT_PLEASE_TRY_LATER]: 'Insight is generating,please try again later',
  [types.CAN_NOT_INSIGHT_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,insight is not supported',
  [types.PLEASE_SELECT_ID_TYPE]: 'Choose ID type first',
  [types.INSIGHT_MUST_WITH_MORE_THAN_500_PERSON]: 'Less than 500 people,insight is not supported',
  [types.CAN_NOT_SPREAD_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,diffuse is not supported',
  [types.CAN_NOT_SPREAD_CROWD_PACKAGE_500_UNTIL_MILLION]: 'Less than 500 or more than 1 million people,diffuse is not supported',
  [types.SYNC]: 'Sync',
  [types.SYNCING_PLEASE_WAIT]: 'Segment is synchronizing,please try again later',
  [types.SYNCING_CROWD_PACKAGE_PLEASE_WAIT]: '正在同步人群包，请耐心等待',
  [types.CAN_NOT_SYNC_WITHOUT_VALID_CROWD_PACKAGE]: 'Segment has expired,sync is not supported',
  [types.NO_MATCHING_CROWD]: 'No match segment',
  [types.SYNC_SUCCESS]: 'Sync Success',
  [types.GO_TO_DATA_CRYSTAL_PLATFORM]: 'Please go to the Data Crystal platform to view',
  [types.ADVANCE]: 'Go to',
  [types.NO_VALID_CROWD]: 'No expired segment',
  [types.USED]: 'Used',
  [types.CROWD_UPPER_LIMIT]: 'Limit',
  [types.TO_BE_INVALIDATE]: 'Expire Soon',
  [types.SELECT_GRANT_CROWD]: 'Select segment authorization',
  [types.SHOW_TO_AGENT]: 'All Agency Users',
  [types.SHOW_TO_ALL_USER]: 'All Users',
  [types.AT_LEAST_A_CROWD]: 'At least one segment authorization is required, and by default only the creator is visible!',
  [types.ABS_VALUE]: 'Coverage',
  [types.TGI_VALUE]: 'TGI',
  [types.CROWD_PACKAGE_PROPORTION]: 'Coverage %',
  [types.TGI_INDEX]: 'TGI',
  [types.CROWD_COUNT]: 'Count',
  [types.POPULATION_ATTRIBUTE]: 'Demo',
  [types.CONSUME_SCENE]: 'Consumption Scenario',
  [types.CONSUME_SCENE_SHORT]: 'Scenario',
  [types.ONLINE_CHARACTER]: 'Cellphone',
  [types.APP_CATEGORY]: 'Media',
  [types.DISTINGUISH_FEATURE]: 'Significant Tags',
  [types.GENDER_DISTRIBUTE]: 'Gender',
  [types.AGE_DISTRIBUTE]: 'Age',
  [types.PROGRAM_PREFERENCE]: 'Program Preference',
  [types.MEDIA_PREFERENCE]: 'Media Interests',
  [types.CONSUME_PREFERENCE]: 'Consumption Preference',
  [types.SHOPPING_PREFERENCE]: 'Shopping Tendency',
  [types.SAVE_PAGE_AS_PICTURE]: 'Save as Picture',
  [types.INSIGHT_REPORT_DOWNLOAD]: 'Download segment insight report',
  [types.PERSONAL_PORTRAY_DOWNLOAD]: 'Download personal portrait',
  [types.ACTIVE_PERSON_RECENT_15_DAYS]: 'Last two weeks',
  [types.ACTIVE_PERSON_RECENT_30_DAYS]: 'Last month',
  [types.ACTIVE_PERSON_RECENT_60_DAYS]: 'Last two months',
  [types.SELECT_CONDITION_NONE]: 'Segment Definition: None',
  [types.SELECT_CONDITION]: 'Segment Definition',
  [types.LOOKALIKE_SELECT_CONDITION]: 'Lookalike Dimension',
  [types.SELECT_TIME]: 'Look Back',
  [types.SELECTED_RANGE]: 'Range',
  [types.ADDRESS]: 'Address',
  [types.SPREAD_CONDITION]: 'Diffusion conditions',
  [types.SEED_CROWD_COUNT]: '种子人群数',
  [types.SPREAD_CROWD_COUNT]: '扩散人群数',
  [types.TO_BE_INVALIDATE_CROWD_PACKAGE_COUNT]: 'Segment expired soon: {total}',
  [types.SEARCH_TAG]: 'Search Tag',
  [types.MATCH_TAG]: 'Match Tag',
  [types.SELECTED_TAG]: 'Selected Tag',
  [types.TAG_LIST]: 'Tag List',
  [types.CROWD_IS_CREATING_PLEASE_WAIT]: 'The segment is creating,please wait',
  [types.CONDITION_COMBINE_ERROR]: 'Conditional combination error',
  [types.NAME_LENGTH_NO_MORE_THAN_20]: 'Name length should not exceed 20',
  [types.LOOK_COVERAGE_CROWD]: 'View coverage',
  [types.SAVE_SUCCESS]: 'Save Success',
  [types.SAVE]: 'Save',
  [types.PLEASE_INPUT_MATCH_CONTENT]: 'Please enter the content to match,such as "male, smart wear"',
  [types.DEFAULT_CONDITION]: 'Default OP',
  [types.UNMATCHED_TAG]: 'Unmatched tag',
  [types.EXIST_TAG]: 'Existing tag',
  [types.PLEASE_INPUT_SEARCH_CONTENT]: 'Please enter search content',
  [types.PLEASE_INPUT_SEARCH_CONDITION]: 'Please enter search condition',
  [types.SEARCH_CONDITION]: 'Search Condition',
  [types.PLEASE_INPUT_TAG_NAME]: 'Please enter tag name',
  [types.AND]: 'AND',
  [types.OR]: 'OR',
  [types.NOT]: 'NOT',
  [types.MINUS]: 'SUB',
  [types.LEFT_PARENTHESIS]: '(',
  [types.RIGHT_PARENTHESIS]: ')',
  [types.PLEASE_CONFIG_TAG_COMBINE]: 'Please configure the tag combination',
  [types.SQL_START_REQUEST]: 'Can not start with a symbol. If start with a symbol, it must be "(" or "not"',
  [types.SQL_NOT_SYMBOL_REQUEST]: 'There must be a symbol before "Not"',
  [types.SQL_LEFT_BRACKET_REQUEST]: 'Before "(" cannot be a tag or ")"',
  [types.ATTENTION_SYMBOL_SPACE]: 'Please note the tag and symbol spacing',
  [types.SQL_RIGHT_BRACKET_REQUEST]: 'After ")" must be a symbol',
  [types.CAN_ONLY_END_WITH_RIGHT_BRACKET]: 'Can not end with a symbol except ")"',
  [types.BRACKET_NOT_MATCH]: 'Bracket mismatch',
  [types.NOT_SYMBOL_MUST_AFTER_AND_OR]: 'Need to have "Intersect" or "Join" before "Not"',
  [types.CREATING]: 'Generating',
  [types.SPREADING]: '扩散中',
  [types.PLEASE_SELECT_POSITION]: 'Please select One LBS at least',
  [types.PLEASE_SET_DISTANCE_0_5_KM]: 'Please set the distance to 0-5km',
  [types.PLEASE_CONFIRM_DISTANCE_ORDER]: 'Please confirm the range size order',
  [types.EDIT_CROWD_SUCCESS]: 'Edit Success',
  [types.CREAT_CROWD_SUCCESS]: 'Create Success',
  [types.EDIT_CROWD_NAME_SUCCESS]: 'Edit Segment Name Success',
  [types.CROWD_NO_UPDATE]: 'The segment has not been modified',
  [types.PLEASE_INPUT_NO_MORE_THAN_20_LENGTH_CROWD_NAME]: '请输入20字以内人群名称',
  [types.SELECT_RESULT]: 'Selected result',
  [types.NATIONWIDE]: 'China',
  [types.TELEPHONE]: 'Telephone',
  [types.NOT_NATCH_LONGITUDE_AND_LATITUDE]: 'Not matched to latitude and longitude',
  [types.SEARCH_LONGITUDE_AND_LATITUDE]: 'Search by ocation, store name or longitude/latitude',
  [types.BATCH_SEARCH]: 'Batch Search',
  [types.BATCH_SEARCH_SHORT]: 'Search',
  [types.FILTER_CITY]: 'Screening cities',
  [types.CHECK_ALL_THIS_PAGE]: 'Select this page',
  [types.ESTIMATE_PERSON]: 'predict',
  [types.PLEASE_SELECT_SEARCH_RESULT]: 'Please select search result',
  [types.PLEASE_INPUT_CORRECT_NUM]: 'Please enter the correct number',
  [types.CUSTOM_RANGE_IN_0_5_KM]: 'Custom range is between 0km-5km',
  [types.START_RANGE_LESS_THAN_END_RANGE]: 'Start range cannot be greater than the end range',
  [types.CUSTOM_RANGE_CONTAIN_2_DECIMAL]: 'Custom range decimal reserves at most two digits',
  [types.LBS_NAME]: 'LBS name',
  [types.BATCH_CREATE]: 'Batch Create',
  [types.LBS_QUAN_REN]: 'LBS circle',
  [types.ENTER_LBS_SEARCH]: 'Create',
  [types.WAIT_LBS_SEARCH_PER_ONE_AND_A_HALF_HOUR]: 'Each LBS information takes about 1.5 hours to query number of users,please wait patiently,the calculation completion time is related to the number of LBS information submitted',
  [types.SEED_COUNT]: 'Origin ID #',
  [types.DIFFUSE_COUNT]: 'Lookalike ID #',
  [types.SPREAD_TIMES]: 'Times',
  [types.SEED_CROWD_NAME]: 'Origin Segment Name',
  [types.CROWD_AUTH]: 'Visible To',

  [types.PC]: 'PC',
  [types.MOBILE]: 'Mobile',
  [types.OTT]: 'OTT',
  [types.TV]: 'TV',
  [types.IOS]: 'iOS',
  [types.ANDROID]: 'Android',
  [types.YOYI_COOKIE]: 'YOYI Cookie',
  [types.COOKIE]: 'Cookie',
  [types.IDFA_IMEI]: 'IDFA & IMEI',
  // options
  [types.STATUS_CREATED]: 'Created',
  [types.STATUS_GENERATING]: 'Generating',
  [types.STATUS_GENERATED]: 'Generated',
  [types.STATUS_SYNCHRONIZING]: 'Synchronizing',
  [types.STATUS_SYNCHRONIZED]: 'Synchronized',
  [types.STATUS_EXPIRED]: 'Expired',
  [types.STATUS_DELETE]: 'Delete',
  [types.STATUS_MATCH_COUNT_LESS]: 'Match count less than 500',
  [types.CUSTOM_LABEL]: 'custom label',
  [types.LBS_UPLOAD_CREATE_NOTICE]: 'Note: The file format is: name, location, city',
  [types.LBS_SEARCH_CREATE_NOTICE]: 'Note: Each LBS segment takes about 1.5 hours to generate.',
  [types.SUPPORT]: 'Support',

  [types.LOGOUT]: 'Logout',
  [types.ACCOUNT_MANAGEMENT]: 'Account Management',
  [types.ROLE_MANAGEMENT]: 'Role Management',
  [types.FINANCE_MANAGEMENT]: 'Finance Management',
  [types.MODIFY_PASSWORD]: 'Change Password',
  [types.USER_MANAGEMENT]: 'Advertisers',
  [types.AGENT_MANAGEMENT]: 'Agency Management',
  [types.DATA_MANAGEMENT]: 'Reporting',
  [types.MORE_FUNCTION]: 'More',
  [types.DEVICE_ORIGIN]: 'Devcie Source',

  [types.UPPER_BOUND]: 'Max',
  [types.UPPER_QUARTILE]: 'Upper Quartile',
  [types.MIDDLE_QUARTILE]: 'Median',
  [types.LOWER_QUARTILE]: 'Lower Quartile',
  [types.LOWER_BOUND]: 'Min',
  [types.AVERAGE]: 'Mean',

  [types.BEIJING]: 'Beijing',
  [types.TIANJIN]: 'Tianjin',
  [types.SHANGHAI]: 'Shanghai',
  [types.CHONGQING]: 'Chongqing',
  [types.HEBEI]: 'Hebei Province',
  [types.SHANXI]: 'Shanxi Province',
  [types.LIAONING]: 'Liaoning Province',
  [types.JILIN]: 'Jilin Province',
  [types.HEILONGJIANG]: 'Heilongjiang Province',
  [types.JIANGSU]: 'Jiangsu Province',
  [types.ZHEJIANG]: 'Zhejiang Province',
  [types.ANHUI]: 'Anhui Province',
  [types.FUJIAN]: 'Fujian Province',
  [types.JIANGXI]: 'Jiangxi Province',
  [types.SHANDONG]: 'Shandong Province',
  [types.HENAN]: 'Henan Province',
  [types.HUBEI]: 'Hubei Province',
  [types.HUNAN]: 'Hunan Province',
  [types.GUANGDONG]: 'Guangdong Province',
  [types.HAINAN]: 'Hainan Province',
  [types.SICHUAN]: 'Sichuan Province',
  [types.GUIZHOU]: 'Guizhou Province',
  [types.YUNNAN]: 'Yunnan Province',
  [types.SHAANXI]: 'Shaanxi Province',
  [types.GANSU]: 'Gansu province',
  [types.QINGHAI]: 'Qinghai Province',
  [types.TAIWAN]: 'Taiwan Province',
  [types.NEIMENGGU]: 'Inner Mongolia Autonomous Region',
  [types.GUANGXI]: 'Guangxi Zhuang Autonomous Region',
  [types.XIZANG]: 'Tibet Autonomous Region',
  [types.NINGXIA]: 'Ningxia Hui Autonomous Region',
  [types.XINJIANG]: 'Xinjiang Uygur Autonomous Region',
  [types.XIANGGANG]: 'Hong Kong Special Administrative Region',
  [types.AOMEN]: 'Macao Special Administrative Region',
  [types.TAG_COMBINATION]: 'Tag Combination',
  [types.IMPRESSION]: 'Impression',
  [types.CLICK]: 'Click',
  [types.IMPRESSION_NOT_CLICK]: 'Impression not Click',
  [types.SWITCH_OPEN]: 'I',
  [types.SWITCH_CLOSE]: 'O',
  [types.SWITCH_YES]: 'I',
  [types.SWITCH_NO]: 'O',
  [types.GENERATE_EACH_LBS_TO_SEGMENT]: 'Generate each LBS',
  [types.LBS_SWITCH_TIP]: 'Turn on will generate segment for each LBS and LBS set.Turn off will only generate segment for LBS set.',
  [types.GENERATE_INSIGHT]: 'Generate Insight',
  [types.MATCH_INSIGHT]: 'Match Insight',
  [types.UPLOAD_CROWD_NOTE]: 'Note',
  [types.UPLOAD_CROWD_TIP1]: '1. Maximum file size is 1GB',
  [types.UPLOAD_CROWD_TIP2]: '2. Support xls, xlsx, csv, txt',
  [types.UPLOAD_CROWD_TIP3]: '3. Only for delivery,please turn off the switch.For insight,please turn on the switch.',
  [types.UPLOAD_CROWD_TIP4]: '4. Support data type:IMEI_MD5, IDFA, IDFA_MD5, YOYIcookie, 3rd Party cookie.YOYIcookie refers to the cookie collected by Databank;3rd Party cookie support part of Baidu, Sohu, Tanx cookies that have done cookiemapping with YOYI.',
  [types.BIDDEN_CROWD_NOTE]: 'Note',
  [types.BIDDEN_CROWD_TIP1]: '1. Maximum file size is 1GB',
  [types.BIDDEN_CROWD_TIP2]: '2. Support xls, xlsx, csv, txt',
  [types.BIDDEN_CROWD_TIP3]: '3. 上传文件支持xlsx，xls格式',
  [types.BIDDEN_CROWD_TIP4]: '4. 单个文件最多支持20行，即一次最多支持批量创建20个人群',
  [types.BIDDEN_CROWD_TIP5]: '5. 单个人群支持最多200个订单/项目/计划ID',
  [types.BIDDEN_CROWD_TIP6]: '6. 上传文件后需先进行校验，系统将校验所填订单/项目/计划ID是否存在于所选广告主下，请校验通过后再进行创建',
  [types.LBS_CROWD_NOTE]: 'Note',
  [types.LBS_CROWD_TIP1]: '1. Turn on will generate segment for each LBS and LBS set.Turn off will only generate segment for LBS set.',
  [types.LBS_CROWD_TIP2]: '2. The range is left open and right closed; For example, if 1~5KM is set, the data of 1<peripheral radius<=5 is calculated.',
  [types.LBS_CROWD_TIP3]: '3. Support xls, xlsx',
  [types.LBS_CROWD_TIP4]: '4. The upload file needs to contain three columns of information: place name, detailed address, and city. See template for details',
  [types.BOXPLOT_OUTLINER_UP_COUNT]: 'Outlier',
  [types.BOXPLOT_OUTLINER_UP_RATE]: 'Outlier Rate',
  [types.BOXPLOT_OUTLINER_DOWN_COUNT]: 'Outlier',
  [types.BOXPLOT_OUTLINER_DOWN_RATE]: 'Outlier Rate',
  [types.INQUIRY_CREATE]: 'Create Inquiry API',
  [types.INQUIRY_EDIT]: 'Edit Inquiry API',
  [types.INQUIRY_API_NAME]: 'Inquiry API Name',
  [types.INQUIRY_JAR_PACKAGE_PATH]: 'JAR Package Path',
  [types.INQUIRY_API_DESC]: 'API Description',
  [types.INQUIRY_PLEASE_INPUT_API_NAME]: 'Please Input API Name',
  [types.INQUIRY_PLEASE_INPUT_JAR_PACKAGE_PATH]: 'Please Input JAR Package Path',
  [types.INQUIRY_PLEASE_INPUT_API_DESC]: 'Please Input API Description',

  [types.SOURCE_CROWD_TYPE]: 'Origin Segment Type',
  [types.SOURCE_CROWD_PACKAGE]: 'Origin Segment',
  [types.INQUIRY_2TIMES_PACKAGE]: '2+times inquiry Segment',
  [types.DAILY_INQUIRY_TIME]: 'Daily Inquiry Time',
  [types.OCLOCK]: 'o\'clock',
  [types.SOURCE_PACKAGE]: 'Source Segment',
  [types.NEW_PACKAGE]: 'New Segment',
  [types.SOURCE_PACKAGE_NEW_PACKAGE]: 'Source Segment+New Segment',
  [types.FTP_PATH]: 'FTP Path',
  [types.ORIGIN_SEGMENT_TYPE]: 'Origin Segment Type',
  [types.CREATE_MAP_CREATE]: 'Create by Map',
  [types.CREATE_UPLOAD_CREATE]: 'Create by Upload',
  [types.SYNC_PLUS_START_DATE_TIP]: 'Start syncing the crowd data to PLUS on this day.Recommend to choose the day before the start of delivery.',
  [types.SYNC_PLUS_END_DATE_TIP]: 'After this day,the crowd data will no longer be available in the PLUS delivery system.Recommend to choose  the end date of delivery.',
  [types.SYNC_PLUS_SWITCH_TIP]: 'Turn on will update the crowd coverage ID data every day; Turn off will not update.',
  [types.SYNC_PLATFORM_START_DATE_TIP]: 'Start syncing the crowd data to platform on this day.Recommend to choose the day before the start of delivery.',
  [types.SYNC_PLATFORM_END_DATE_TIP]: 'After this day,the crowd data will no longer be available in the platform delivery system.Recommend to choose  the end date of delivery.',
  [types.SEGMENT_DOWNLOAD]: 'Segment Download',
  [types.SEGMENT_COMPARE]: 'Segment Compare',

  [types.SEGMENT_PERSON]: 'Individual Segment',
  [types.SEGMENT_FAMILY]: 'Household Segment',
  [types.BACK_LAST_LEVEL]: 'Back',

  [types.PERSON]: 'person',
  [types.FAMILY]: 'Household',
  [types.FAMILY_INSIGHT_OVERVIEW]: 'Overivew',
  [types.FAMILY_PROPERTY]: 'Demo',
  [types.FAMILY_STRUCTURE]: 'Household Structure',
  [types.FAMILY_AGE]: 'Age',
  [types.TV_BRAND]: 'TV Brand',
  [types.CROSS_NUMBER]: 'Cross-screen Devices',
  [types.RESULT_DOWNLOAD]: 'Result Download',
  [types.RESULT_DOWNLOAD_TIP]: 'Number of download exceeds the system limit. Please download result by city.',

  [types.CROWD_CONVERSE]: 'Convert',
  [types.CONVERSE_CROWD]: 'Converted Segment',
  [types.ORIGIN_SEGMENT_NAME]:'Origin Segment',
  [types.ORIGIN_SEGMENT_ID_TYPE]:'Origin Segment ID Type',
  [types.NAME]: 'Name',
  [types.SYNC_OVER_TIP]: 'The current segment size is too large and exceeds the maximum synchronization limit of the system, which may cause synchronization tasks to be delayed. Please check whether the segment creation conditions are normal. If you need to continue the synchronization, you need to review by the administrator. After the review, the crowd will be synchronized normally. Do you continue to submit?',

  [types.REPORT]: '统计报表',
  [types.REPORT_SEGMENT]: 'Segment Report',
  [types.DATA_TYPE]: 'Data Type',
  [types.GEO]: 'Geo Location',
  [types.FAMILY_GENDER]: 'Gender',
  [types.FAMILY_STRUCTURE_SINGLE]: 'Single',
  [types.FAMILY_STRUCTURE_COUPLE]: 'Couple',
  [types.FAMILY_STRUCTURE_CHILDREN]: 'Parents and Children',
  [types.FAMILY_STRUCTURE_THREE]: 'Three Generations',
  [types.USER]: 'Individual',

  [types.THIRD_PARTY_INQUIRY]: '三方问询',
  [types.PROJECT_MANAGEMENT]: '项目管理',
  [types.DATA_REPORT]: '数据报表',
  [types.INQUIRY_START]: '问询开始',
  [types.INQUIRY_DOING]: '问询中',
  [types.INQUIRY_DONE]: '问询完成',

  [types.DNA_COPY_CROWD]: 'Copy to Plus',
  [types.TRAFFIC_CROWD]: 'Inventory  segment',
  [types.SPLIT_CROWD]: 'Split segment',
  [types.CROWD_EFFECT]: '效果定制人群',
  [types.ACTIVE_CROWD]: '活动人群',

  [types.IDFA]: 'IDFA',
  [types.IDFA_MD5]: 'IDFA MD5',
  [types.IMEI]: 'IMEI',
  [types.IMEI_MD5]: 'IMEI MD5',
  [types.ANDROIDID]: 'Android ID',
  [types.ANDROIDID_MD5]: 'Android ID MD5',
  [types.OAID]: 'OAID',
  [types.OAID_MD5]: 'OAID MD5',

  [types.FTP_MANAGE]: 'FTP Management',
  [types.PLATFORM_MANAGE]: 'Platform Management',
  [types.ABSOLUTE_TIME]: '绝对时间',
  [types.RELATIVE_TIME]: '相对时间',
}